
// export const myGetter = ( output ) => {
//  return output
// }

export const outputsList = state => state.outputs
export const outputsPaginatedData = state => state.outputsPaginatedData
export const output = state => state.output
export const isLoading = state => state.isLoading